import base from "../baseurl";
import token from "../getTk";

const Create = async (titleWorkSheet, ElectionUuid, WorkSheetImg) => {
  const tokenA = token.get();
  const api = base.extend({
    hooks: {
      beforeRequest: [
        (request) => {
          request.headers.set("jwt", `${tokenA}`);
        },
      ],
    },
  });
  console.log(titleWorkSheet, ElectionUuid, WorkSheetImg);
  const Create = await api
    .post("candidate-worksheets/create", {
      json: {
        candidateWorkSheetData: { name: titleWorkSheet, img: WorkSheetImg },
        candidates: [],
        electionUuid: ElectionUuid,
      },
    })
    .json();
  console.log("create response", Create);
  return Create;
};
export default Create;
